module.exports = __webpack_public_path__ + "img/coconut.5ef5e97d.png";